import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import incomeStatementTemplate from './incomeStatement.template.html';

export default angular
  .module('books.ui.incomeStatement', [csmCommonWeb, booksService])
  .directive('incomeStatement', incomeStatementDirective).name;

/* @ngInject */
function incomeStatementDirective(BooksSvc, BusyScreen) {
  return {
    template: incomeStatementTemplate,
    scope: {
      /* acctSin
      /* Label for type of report in singular format
      /*
      /* acctPL 
      /* Label for type of report in plural format
      /* 
      /* reportByHide 
      /* Hides the "report by" div when true.
      /* 
      /* sortByHide 
      /* Hides the "sort by" div when true.
      */
      acctSin: '@',
      acctPl: '@',
      reportByHide: '@',
      sortByHide: '@'
    },
    link: function ($scope, element, attr) {
      var mGroups = [];
      var mAllOption = { id: 0, description: 'All Groups' };

      /*---------------------------------------------------------*/
      /* Sets the defaults of the report to be pulled by account */
      /* and account name and puts the report in PDF format.     */
      /*---------------------------------------------------------*/
      $scope.req = {
        groupAccts: false,
        order: 'NAME',
        reportFormat: 'PDF'
      };
      $scope.data = {};

      /*****************************************************************************
       * checkGroup */
      /**
       * Verifies the groupID entry. If -1 clears the text on blur.
       *****************************************************************************/
      $scope.checkGroup = function () {
        if ($scope.req.groupID == -1) {
          $scope.data.group = null;
        }
      };

      /*--------------------------------------------------*/
      /* Watches the data.group and sets the groupID to   */
      /* -1 (all groups) if an invalid selection was made */
      /*--------------------------------------------------*/
      $scope.$watch('data.group', function (group) {
        var groupSelected = group && angular.isObject(group);
        $scope.req.groupID = groupSelected ? group.id : -1;
      });

      /*--------------------------------------------------------*/
      /* Adds the mAllOption to the top of the groups typeahead */
      /*--------------------------------------------------------*/
      $scope.getGroups = function (text) {
        return [mAllOption].concat(
          mGroups.filter(function (g) {
            return g.description.toLowerCase().indexOf(text.toLowerCase()) > -1;
          })
        );
      };

      /*****************************************************************************
       * reportByAccount */
      /**
       * Sets the report to be pulled by the account and checks that the groupID is 0
       *****************************************************************************/
      $scope.reportByAccount = function () {
        $scope.req.groupAccts = false;
        $scope.req.groupID = 0;
      };

      /*****************************************************************************
       * reportByGroup */
      /**
       * Sets the report to be pulled by the group and allows the selection of which
       * group can be pulled
       *****************************************************************************/
      $scope.reportByGroup = function () {
        $scope.req.groupAccts = true;
      };

      /*------------------------------------------------------*/
      /* Works with CSMValidator and checks to make sure that */
      /* the start date and end date fields are populated.    */
      /*------------------------------------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /*--------------*/
      /* Get services */
      /*--------------*/
      BooksSvc.getAccountGroups().then(function (resp) {
        mGroups = resp.data.sort(function (a, b) {
          return a.description
            .toLowerCase()
            .localeCompare(b.description.toLowerCase());
        });

        BooksSvc.getOrganization().then(function (resp) {
          $scope.org = resp.data;
        });
        BusyScreen.setBusy(false);
      });
    }
  };
}
